import { useCallback } from 'react';

import type { ITableConfigParserOptions } from '../../api/fetchers/tableConfig/types';
import { fetchTableConfigAction } from '../apiActions/fetchTableConfigAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useTableConfigFetcher = (parserOptions: ITableConfigParserOptions, essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const JSESSIONID = useConfigSlice.JSESSIONID();
  const tableId = useConfigSlice.tableId();
  const baseUrl = useConfigSlice.baseUrl();
  const session = useConfigSlice.session();
  const operatorNotification = session?.referer === 'lobby';

  return useCallback((): void => {
    if (JSESSIONID && tableId && baseUrl) {
      dispatch(
        fetchTableConfigAction({
          baseUrl,
          parserOptions,
          params: { JSESSIONID, tableId, operatorNotification },
          essential,
        })
      );
    }
  }, [JSESSIONID, baseUrl, dispatch, parserOptions, tableId, essential, operatorNotification]);
};
